<div class="container-fluid bg-white shadow-sm mt-4">
  <div class="d-flex flex-row align-items-center">
    <h1 class="page-title" *ngIf="!isAnalysisPage">
      Location
      <span class="text-dark">{{contract.location.getShortLabel()}} - {{contract.location.name}}
        <span *ngIf="contract.location.city || contract.location.region" class="small text-muted ps-1">
          ({{ contract.location.city }}{{ contract.location.city && contract.location.region ? ', ' : '' }}{{
          contract.location.region }})
        </span>
      </span>
      <span *ngIf="contract.companyChild && contract.companyChild?.name">
        ({{contract.companyChild.getDisplayName()}})</span>
      <span *ngIf="!(contract.companyChild && contract.companyChild?.name) && contract.companyInfo">
        ({{contract.companyInfo}})</span>
    </h1>
    <ul class="nav nav-links ms-3">
      <!--
        Dashboard / Vertical Analysis / Index Analytics are LOCKED for a sealed tender while
        any round of it is still open, and come back untouched once every round is closed.
        canAccessAnalysisScreens() is the browser's copy of the server's
        can_access_sealed_tender_for_closed_rounds() and reads the same fact
        (tender.isClosedRounds), so the tabs and the endpoints cannot disagree: no tab renders
        that would answer 403 when clicked, and none is hidden that would have worked.

        This replaces three per-tab copies of a round-number rule that pointed a sealed
        airline's Dashboard at round N-1 while round N was open. The lock the owner asked for
        is tender-wide, so there is no "previous round" exception to encode any more, and one
        link per tab is enough for both tender types.
      -->
      <li class="nav-item" *ngIf="canAccessAnalysisScreens()">
        <a class="nav-link" data-testid="contract-tab-dashboard"
          [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'round', contract.currentRound.round]"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          Dashboard
        </a>
      </li>
      <li class="nav-item" *ngIf="canAccessAnalysisScreens()">
        <a class="nav-link" data-testid="contract-tab-analysis"
          [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'analysis', 'round', contract.currentRound.round]"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          Vertical Analysis
        </a>
      </li>
      <li class="nav-item" *ngIf="canAccessAnalysisScreens()">
        <a class="nav-link" data-testid="contract-tab-index-analysis"
          [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'index-analysis', 'round', contract.currentRound.round, 'graph']"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          Index Analytics
        </a>
        <!--        <a *ngIf="!user.settings.platts_subscriber" class="nav-link" href="javascript:void(0);"-->
        <!--          (click)="permissionMessage()">-->
        <!--          Index Analytics-->
        <!--        </a>-->
      </li>
      <li class="nav-item">
        <div class="nav-divider"></div>
      </li>
      <li *ngIf="user.canManageAdvanced(tender)" class="nav-item">
        <a class="nav-link" [ngbPopover]="candelContractConfirmation" popoverTitle="" (click)="$event.preventDefault()"
          placement="left" href="javascript:void(0);">
          Cancel Location
        </a>
        <ng-template #candelContractConfirmation>
          <p class="mb-2"><strong>Attention! This actions can not be undone.</strong> Suppliers will receive a location
            cancellation notification and this location will be marked as cancelled.</p>
          <div class="row">
            <div class="col pe-1">
              <button (click)="p.close()" class="btn btn-link w-100">
                Resume
              </button>
            </div>
            <div class="col ps-1">
              <button (click)="cancelContract()" class="btn btn-danger w-100" [disabled]="cancellingLocation">
                <span *ngIf="cancellingLocation">
                  <div class="spinner-border spinner-border-sm me-1" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span>Cancelling...</span>
                </span>
                <span *ngIf="!cancellingLocation">Confirm</span>
              </button>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>

    <ul class="nav nav-links ms-auto">
      <li class="nav-item d-flex align-items-center">
        <div class="actions">
          <div class="btn-group" role="group">

            <!-- <button *ngIf="!contract.pagination['prev']" type="button" class="btn btn-link" disabled>
              <span aria-hidden="true">&laquo;</span>
              <span class="visually-hidden">Previous</span>
            </button> -->

            <button *ngIf="contract.pagination['prev']" [routerLink]="['/tenders', tender.id, 'locations',
                                                  contract.pagination['prev']['id'], 'analysis', 'round', round.round]"
              type="button" class="btn btn-link"
              [ngbTooltip]="'Go to ' + contract.pagination['prev']['location']['iata'] + ' location'">
              <a href="javascript:void(0);" class="page-link" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span class="visually-hidden">Previous</span>
                Previous Location
              </a>
            </button>

            <!-- <button type="button" class="btn btn-link">
              <span class="small text-muted">({{contract.pagination['num_current']}} of
                {{contract.pagination['num_all']}})</span>
            </button> -->

            <!-- <button *ngIf="!contract.pagination['next']" type="button" class="btn btn-link" disabled>
              <span aria-hidden="true">&raquo;</span>
              <span class="visually-hidden">Next</span>
            </button> -->
            <button *ngIf="contract.pagination['next']" [routerLink]="['/tenders', tender.id, 'locations',
                                                  contract.pagination['next']['id'], 'analysis', 'round', round.round]"
              type="button" class="btn btn-link"
              [ngbTooltip]="'Go to ' + contract.pagination['next']['location']['iata'] + ' location'">
              <a href="javascript:void(0);" class="page-link" aria-label="Next">Next Location
                <span aria-hidden="true">&raquo;</span>
                <span class="visually-hidden">Next</span>
              </a>
            </button>
          </div>
        </div>
      </li>
      <li class="nav-item" *ngIf="!isAnalysisPage">
        <div class="nav-divider"></div>
      </li>
      <li class="nav-item" *ngIf="!isAnalysisPage">
        <a class="nav-link pe-lg-0" href="javascript:void(0);" (click)="collapseStats()"
          [attr.aria-expanded]="!isCollapsed" aria-controls="collapseAirlineRequirements">
          Airline Requirements <i class="fas" [class.fa-angle-right]="isCollapsed"
            [class.fa-angle-down]="!isCollapsed"></i>
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid bg-white shadow-sm border-top stats" id="collapseAirlineRequirements"
  [ngbCollapse]="isCollapsed" *ngIf="!isAnalysisPage">
  <div class="row text-start">
    <div class="col-12 col-sm-4 col-lg-2 border-top">
      <div class="field border-end">
        <div class="label">Contract Start Date</div>
        <div class="small text-muted">
          <span>{{contract.dateStart | date: defaultDateFormat : 'utc'}}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top">
      <div class="field border-end">
        <div class="label">Contract End Date</div>
        <div class="small text-muted">
          <span>{{contract.dateEnd | date: defaultDateFormat : 'utc'}}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top">
      <div class="field border-end">
        <div class="label">Tender Round</div>
        <div class="small text-muted">
          <jft-tender-time-remaining [date]="tender.dateRoundEnd" [tenderStatus]="tender.status" type="end">
          </jft-tender-time-remaining>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top">
      <div class="field border-end">
        <div class="label">Round Start Date & Time</div>
        <div class="small text-muted">
          <span *ngIf="tender.dateActivated">{{tender.dateActivated | date: 'MMM dd, yyyy HH:mm' : 'utc'}}</span>
          <span *ngIf="!tender.dateActivated" class="small text-muted">Not Set</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top">
      <div class="field border-end">
        <div class="label">Round End Date & Time</div>
        <div class="small text-muted">
          <span *ngIf="tender.dateRoundEnd">{{tender.dateRoundEnd | date: 'MMM dd, yyyy HH:mm' : 'utc'}}</span>
          <span *ngIf="!tender.dateRoundEnd" class="small text-muted">Not Set</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="(contract.companyInfo || contract.companyChild) && !tender?.company?.settings?.isHiddenField('location_company')">
      <div class="field border-end">
        <div class="label">Company</div>
        <div class="small text-muted">
          <span *ngIf="contract.companyChild && contract.companyChild?.name">{{ contract.companyChild.getDisplayName()
            }}</span>
          <span *ngIf="!(contract.companyChild && contract.companyChild?.name) && contract.companyInfo">{{
            contract.companyInfo }}</span>
          <span *ngIf="!(contract.companyChild && contract.companyChild?.name) && !contract.companyInfo"
            class="small text-muted">Not Provided</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.companyInfo && !tender?.company?.settings?.isHiddenField('location_fuel_type')">
      <div class="field border-end">
        <div class="label">Fuel Type</div>
        <div class="small text-muted">

          <span *ngIf="contract.fuelType?.name"> {{contract.fuelType?.name}}</span>
          <span *ngIf="!contract.fuelType?.name" class="small text-muted"> Not Provided
          </span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.flightType && !tender?.company?.settings?.isHiddenField('location_flight_type')">
      <div class="field">
        <div class="label">Flight Type</div>
        <div class="small text-muted">
          <span *ngIf="contract.flightType">
            {{contract.flightType.name}}</span>
          <span *ngIf="!contract.flightType" class="small text-muted">Not Provided</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.flightType && !tender?.company?.settings?.isHiddenField('location_delivery_point')">
      <div class="field border-end">
        <div class="label">Delivery Point</div>
        <div class="small text-muted">
          {{contract.fuelPreference?.name || 'No preference'}}
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="!tender?.company?.settings?.isHiddenField('location_contract_volume')">
      <div class="field border-end">
        <div class="label">Yearly Volume</div>
        <div class="small text-muted" *ngIf="contract.volume">
          {{contract.volume | number : '1.0-0' | usNumber}} <small>{{contract.units.code}}</small>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.monthService && contract.volume && !tender?.company?.settings?.isHiddenField('location_monthly_volume')">
      <div class="field border-end">
        <div class="label">Monthly Volume</div>
        <div class="small text-muted">
          <span *ngIf="contract.monthService">{{contract.volume / contract.monthService | number : '1.0-0' | usNumber }}
            {{contract.units.code}}
          </span>
          <span *ngIf="!contract.monthService" class="small text-muted"> Not Provided
          </span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.monthService && !tender?.company?.settings?.isHiddenField('location_months_of_service')">
      <div class="field border-end">
        <div class="label">Months of Service</div>
        <div class="small text-muted">

          <span *ngIf="contract.monthService"> {{contract.monthService}}
          </span>
          <span *ngIf="!contract.monthService" class="small text-muted"> Not Provided
          </span>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="round.totalAwardedPercent > 0 && !tender?.company?.settings?.isHiddenField('location_award_quota')">
      <div class="field border-end">
        <div class="label">
          Award Quota (%)
          <ng-template #popAwardQuotaContent>Percentage of total contract volume to be awarded to each supplier.
            <hr>
            Every supplier will be bidding for a maximum of <b>{{
              round.totalAwardedPercent }}%</b> of <b *ngIf="contract.volume">{{contract.volume | number : '1.0-0' |
              usNumber }}
              {{contract.units.code}}</b> at
            this location, which is <b *ngIf="contract.volume && contract.awardQuota">{{contract.volume / 100 *
              contract.awardQuota |
              number : '1.0-0' | usNumber }}
              {{contract.units.code}}</b>
          </ng-template>
          <ng-template #popAwardQuotaTitle>Award Quota (%)</ng-template>
          <a class="pointer" placement="right" [ngbPopover]="popAwardQuotaContent" [popoverTitle]="popAwardQuotaTitle">
            <i class="fa-solid fa-circle-info"></i>
          </a>
        </div>
        <div class="small text-muted">
          {{ round.totalAwardedPercent }} <small>%</small>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.averageUplift && !tender?.company?.settings?.isHiddenField('location_average_uplift')">
      <div class="field">
        <div class="label">Average Uplift per Flight</div>
        <div class="small text-muted">
          <span *ngIf="contract.averageUplift">{{contract.averageUplift | number : '1.0' | usNumber }}
            {{contract.units.code}}</span>
          <span *ngIf="!contract.averageUplift" class="small text-muted">Not Provided</span>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="!tender?.company?.settings?.isHiddenField('location_annual_frequency')">
      <div class="field">
        <div class="label">Annual Frequency</div>
        <div class="small text-muted">
          <span *ngIf="contract.annualFrequency">
            {{contract.annualFrequency}}</span>
          <span *ngIf="!contract.annualFrequency" class="small text-muted">Not Provided</span>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-4 col-lg-2 border-top"
      *ngIf="contract.branded && !tender?.company?.settings?.isHiddenField('location_branded')">
      <div class="field">
        <div class="label">Branded</div>
        <div class="small text-muted">
          <span>{{ contract.branded ? 'Yes' : 'No' }}</span>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-12 border-top" *ngIf="!tender?.company?.settings?.isHiddenField('location_notes')">
      <div class="field">
        <div class="label">Locations Notes</div>
        <div class="text-muted small mb-0">
          {{contract.notes}}
          <span *ngIf="!contract.notes" class="">Not Provided</span>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>